import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import SidebarUserbox from 'layout-components/SidebarUserbox';
import SidebarMainMenuLinksForMobile from 'layout-components/SidebarMainMenuLinksForMobile';
import SidebarMenu from './SidebarMenu';
import SidebarThemeList from './SidebarThemeList';
import HeaderLogo from './HeaderLogo';
import { COLLAPSED_SIDEBAR_WIDTH, SIDEBAR_WIDTH } from 'config/appConfig';
import { useLocation } from 'react-router-dom';

const SidebarMainContent = () => {
  const location = useLocation();
  const selectedItem = useSelector(state => state.Watchlist.selectedItem);
  const isTopicPage = ['/topic'].includes(location.pathname);

  return (
    <>
      <Grid container direction="column" style={{ height: '100vh', width: SIDEBAR_WIDTH }}>
        <PerfectScrollbar options={{ wheelPropagation: false }}>
          <Grid container direction="column">
            <Grid item>
              <HeaderLogo />
            </Grid>
            <Hidden mdUp>
              <Grid item>
                <SidebarMainMenuLinksForMobile />
              </Grid>
            </Hidden>
            {!isTopicPage && selectedItem ? (
              <Grid item>
                <SidebarUserbox />
                <Divider />
              </Grid>
            ) : null}
            {isTopicPage ? (
              <Grid item style={{ padding: `4px 0 4px ${COLLAPSED_SIDEBAR_WIDTH}px` }}>
                <SidebarThemeList />
              </Grid>
            ) : (
              <Grid item>
                <SidebarMenu />
              </Grid>
            )}
          </Grid>
        </PerfectScrollbar>
      </Grid>
    </>
  );
};

export default SidebarMainContent;
